import { render, staticRenderFns } from "./OAppFooter.vue?vue&type=template&id=44d29db3&scoped=true&"
import script from "./OAppFooter.vue?vue&type=script&lang=js&"
export * from "./OAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./OAppFooter.vue?vue&type=style&index=0&id=44d29db3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d29db3",
  null
  
)

export default component.exports